import Cookies from 'js-cookie'

import { COOKIE_NAME } from '@comparacar/lib/src/utils/ab-testing'

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TAG!

export const pageview = (url: URL) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url
  })
}

export const event = (
  action: Gtag.EventNames | 'A_B_TESTING',
  { event_category, event_label, value }: Gtag.EventParams
) => {
  const AB_TEST_VERSION = Cookies.get(COOKIE_NAME)
  window.gtag('event', action, {
    ab_version: AB_TEST_VERSION,
    event_category,
    event_label,
    value
  })
}
